import { render, staticRenderFns } from "./AddonsFileTable.vue?vue&type=template&id=0c1b187e&"
import script from "./AddonsFileTable.vue?vue&type=script&lang=js&"
export * from "./AddonsFileTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports